import { cx } from '@linaria/core';
import { mdiChevronDown, mdiChevronRight } from '@mdi/js';
import MdiIcon from '@mdi/react';
import { ReactNode, useId } from 'react';
import Button from '../Buttons/Button';
import { Legend } from './Fieldset';
import InfoTooltip from './InfoTooltip';
import PopoverSelect from './PopoverSelect';
import Radio from './Radio';
import "./Settings.linaria.module.css!=!./Settings?./Settings.linaria.module.css?css=H4sIAAAAAAAAA41W3a6jOAy+36fozerMaIeKUHraw0ir3bu92WeIAkkgEBJIUn6K5t1XLYUT0452rpAdfw62PzveE1fjD4uRG3rRyYkK20gyJlyy4fuP3/a3Y2IwSptYV9lGnG5WARWGZU5olWRaXmq1wLIBc5cLGU05aZJzs/qTGiPeD6pjG3FqCKVC5YHTTYIiD8Eggj0hUu2criFIYzTGsZZ8I4JrYniLD2BPgMctHqbAqHjX5eUKpYlIkatAOFbbJGPKMeOlZXF7y4vni0UYuSwvj/lUMJEXLom8U25wRhHXk2TOMRPYhmRC5Um4Dz9YvcZQwRiqpxgk4w5ELSFCPiHM/V9gogRteB5DaZumcLFHWV0eL2yJbpdenNPqVZDZgMciDtM5N14x8ytG/SW36rgRp5qYXKg5LHJxekFUFqNj1/a9mXTHDJe6TwpBKVsJeuAYxQVJ625KtaHMJKgZdlZLQXcdMV+CwJHcBvPZ1wV1LFfyzSeBIVRcLOBeRHHTuko2UJpSklW50RdFg0xLbZL5HsucEyq3QUYMDT6N1ks/kCXD+/K7f+4fgMDo/g9fWH7p3kC/EAzPAH8/xam8WCf4GGRaOabchsTlO0aEjh8VnWqhgkclY58jFWzZ6qll7xUDDSshRD5BZib6mHTASPcVLdONOHGtXMBJLeSYvP2rlbPMGOLevr39w2THnMjI27e3v40g8u2bJcoGlhnBVyaecY/ybkyhNLu14soSdPB4a7ESJxnmUJqt+zk77+HaECeJkR1PBesmQANHFL0xwLHBrTXqRoy0bXXUTb2grkhQGP7ucfjRfA8Khx4FURmdyyHaiM8kdIYo2xDDlFvQ5oAROxatJdPtZ4L7PEtuJVspWWInKxbKKbsYq03SaPGgyF81o4LsvhS3xkt298/XaWbYdXChxeiUZ++k+TVVMvtR2n1JqLAklYx+/VkrkcyJjgXznd9/LBNo5OwYM4yGrhw0Wt2A9C9KmH50iq+yfMenA6F96SHnqCnj5CKdP90fpL1NMJ+q3YjzyvGlilH4eURqnMux5/X9RU2UVsw7qtKT6q7zEVo7MF0Kf2vA2eVa+/yAVetCc4LSJIViS7Oi/WF9xA6PqQulZbTehok/ilt/+q/SYr0d/vkVmF835vcpsBoXoW+8Sovx3P+h16P+wPgU/S6NQJemXOWaQwl06RF06TlWXVUDljRG1MSMkCS3huY20l0PG5pl+tbRG2t0bE88vj7Wo1cqb6Tv9rcRbLS8+wBp83aqKO37iGNU9SdVx69UP3fphy9UwYxY6YyyXtBz6RcFqpa33F+p1gSypkU998FAs8U+rQ22bTObgcuBausAcgnVrTs3BsCBagvfsCs/PDoPSrCJvGXTX4n0diUCeZGVX/pVgnGcwcPo28ut/fzjHsB9LPPkPrzv851rU4PJwpc8PG2UPqvbomi1BqzODWMqkEJVK6OH7qLLATw4UPU5N3/l9TkUymQn/0kFmk9nP3lfx/4wDsgfakCz23PBJA2Eai4OlMgbFig8qfdTjpE8pQdiXule+3nQ2NsOaEPTVuDWSsOPz5rXbuaiRv4f6agQLV1qAmH/UyB0jF1Wdf5OA1XQ2+stB8UVZSFYdaDqhZPn4pQpljK9nKn3cqHHa/gfJdqKRo8OAAA="
const sectionStyles = "atm_9s_1txwivl atm_ar_1bp4okc atm_cx_ftgil2 atm_lo_1fwxnve atm_le_1fwxnve";
const compactSectionStyles = "atm_lo_1y44olf atm_le_1y44olf";
const legendStyles = "atm_9s_1txwivl atm_h_1h6ojuz atm_cx_1y44olf atm_e2_1tcgj5g atm_fr_cd1fo atm_lk_1y44olf atm_ll_1y44olf atm_le_idpfg4 atm_1cmj5ue_1tcgj5g";
const auxStyles = "atm_9s_1txwivl atm_cx_yh40bf atm_gz_1wugsn5";
const groupStyles = "atm_9s_1txwivl atm_ar_1bp4okc atm_ks_15vqwwr atm_3f_14habmv atm_5j_1fwxnve atm_2d_pqtklp atm_91sax6_14habmv";
const rowStyles = "atm_9s_1txwivl atm_ar_1bp4okc atm_fc_1h6ojuz atm_j6_1ady9kd atm_lo_1y44olf atm_le_1y44olf atm_lk_1fwxnve atm_ll_1fwxnve atm_bx_1owkdjb atm_c8_w1gvyb atm_cs_ni7l0g atm_7l_1sy7hev";
const rowButtonStyles = "atm_vy_1osqo2v atm_3f_idpfg4 atm_2d_1j28jx2 atm_r3_1e5hqsa atm_9j_tlke0l atm_fzxt0s_17gc6ap atm_1yfe54e_1xvjxo1 atm_174zlj6_73adwj";
const rowMainStyles = "atm_9s_1txwivl atm_h_1h6ojuz atm_cx_1fwxnve";
const iconStyles = "atm_9s_1txwivl atm_fc_1h6ojuz atm_vy_gktfv atm_am_glywfm";
const labelStyles = "atm_am_kb7nvz atm_jb_idpfg4 atm_g3_nqt0r7";
const hintStyles = "atm_h3_yh40bf atm_gq_idpfg4 atm_gz_idpfg4 atm_h0_idpfg4 atm_c8_1fwxnve atm_cs_bfngof atm_7l_84nvkm";
const chevronStyles = "atm_am_glywfm atm_7l_1fs2ovw";
const radioRowStyles = "atm_15q7f4z_ftgil2 atm_2bww2f_1kw7nm4";
const tooltipStyles = "atm_1cwid8j_idpfg4 atm_epq1wf_idpfg4 atm_1sqqcsc_idpfg4 atm_1mqt8pr_idpfg4";
const textButtonStyles = "atm_jb_idpfg4 atm_e2_1tcgj5g atm_g3_kb7nvz atm_lo_idpfg4 atm_le_idpfg4 atm_lk_ftgil2 atm_ll_ftgil2 atm_c8_1fwxnve atm_cs_ni7l0g atm_t9_glywfm atm_fr_idpfg4 atm_7l_1qhhqoo atm_xvuojx_1j28jx2 atm_3hnrc7_ni7l0g";
const inlineSelectStyles = "atm_am_glywfm atm_yw3yx1_yh40bf atm_107n67g_1l7b3ar atm_dpdbqi_qslrf5 atm_1o2hiqd_1qhhqoo atm_154tckv_w1gvyb atm_14kde0s_ni7l0g";
const inlineMenuStyles = "atm_jb_llbu8d";
export const getUeoptOptions = <S extends Record<string, {
  param: string | number;
}>, K extends keyof S>(states: S, keys: Array<K>, labels: NoInfer<Record<K, string>>, testIds: NoInfer<Partial<Record<K, string>>> = {}) => keys.map(key => ({
  label: labels[key],
  value: states[key].param as S[K]['param'],
  'data-testid': testIds[key]
}));
interface SettingsSectionProps {
  aux?: ReactNode;
  children: ReactNode;
  className?: string;
  compact?: boolean;
  'data-testid'?: string;
  description?: ReactNode;
  intro?: ReactNode;
  title?: ReactNode;
}
export const SettingsSection = (props: SettingsSectionProps) => {
  const {
    aux,
    children,
    className,
    compact = false,
    description,
    intro,
    title,
    'data-testid': dataTestId
  } = props;
  return <section className={cx(sectionStyles, compact && compactSectionStyles, className)} data-testid={dataTestId}>
            {title && <Legend asDiv className={legendStyles}>
                    {title}
                    {aux && <span className={auxStyles}>{aux}</span>}
                </Legend>}
            {intro && <p className={hintStyles}>{intro}</p>}
            {children}
            {description && <p className={hintStyles}>{description}</p>}
        </section>;
};
interface SettingsGroupProps {
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
  role?: string;
}
export const SettingsGroup = (props: SettingsGroupProps) => {
  const {
    children,
    className,
    role,
    'data-testid': dataTestId
  } = props;
  return <div className={cx(groupStyles, className)} data-testid={dataTestId} role={role}>
            {children}
        </div>;
};
interface SettingRowProps {
  chevron?: boolean;
  children?: ReactNode;
  className?: string;
  'data-testid'?: string;
  disabled?: boolean;
  expanded?: boolean;
  hint?: ReactNode;
  icon?: ReactNode;
  label: ReactNode;
  onClick?(): void;
}
export const SettingRow = (props: SettingRowProps) => {
  const {
    chevron = true,
    children,
    className,
    disabled,
    expanded,
    hint,
    icon,
    label,
    onClick,
    'data-testid': dataTestId
  } = props;
  const content = <>
            <div className={rowMainStyles}>
                {icon && <span aria-hidden="true" className={iconStyles}>
                        {icon}
                    </span>}
                <div className={labelStyles}>
                    {label}
                    {hint && <p className={hintStyles}>{hint}</p>}
                </div>
                {children}
                {onClick && chevron && <MdiIcon path={expanded ? mdiChevronDown : mdiChevronRight} size={0.9} className={chevronStyles} />}
            </div>
        </>;
  if (onClick) {
    return <button type="button" className={cx('setting-row', rowStyles, rowButtonStyles, className)} aria-expanded={expanded} data-testid={dataTestId} disabled={disabled} onClick={onClick}>
                {content}
            </button>;
  }
  return <div className={cx('setting-row', rowStyles, className)} data-testid={dataTestId}>
            {content}
        </div>;
};
export const SettingsTooltip = ({
  children
}: {
  children: ReactNode;
}) => <InfoTooltip styleOverrides={tooltipStyles}>{children}</InfoTooltip>;
interface TextButtonProps {
  children: ReactNode;
  'data-testid'?: string;
  disabled?: boolean;
  onClick(): void;
}
export const TextButton = (props: TextButtonProps) => {
  const {
    children,
    disabled,
    onClick,
    'data-testid': dataTestId
  } = props;
  return <Button clean size="small" className={textButtonStyles} data-testid={dataTestId} disabled={disabled} onClick={onClick}>
            {children}
        </Button>;
};
interface RadioRowOption<T extends string | number> {
  aux?: ReactNode;
  'data-testid'?: string;
  disabled?: boolean;
  label: ReactNode;
  value: T;
}
interface SettingsRadioGroupProps<T extends string | number> {
  name: string;
  onChange(value: T): void;
  options: Array<RadioRowOption<T>>;
  value: T | undefined;
}
export const SettingsRadioGroup = <T extends string | number,>(props: SettingsRadioGroupProps<T>) => {
  const {
    name,
    onChange,
    options,
    value
  } = props;
  const groupName = `${name}-${useId()}`;
  return <SettingsGroup role="radiogroup">
            {options.map(option => <SettingRow key={String(option.value)} className={radioRowStyles} label={<Radio dense checked={value !== undefined && String(value) === String(option.value)} disabled={option.disabled} name={groupName} value={option.value} label={option.label} data-testid={option['data-testid']} onChange={() => onChange(option.value)} />}>
                    {option.aux}
                </SettingRow>)}
        </SettingsGroup>;
};
interface InlineSelectOption {
  'data-testid'?: string;
  label: ReactNode;
  value: string | number;
}
interface InlineSelectProps {
  'data-testid'?: string;
  name?: string;
  onChange(value: string): void;
  options: Array<InlineSelectOption>;
  value: string | number;
}
export const InlineSelect = (props: InlineSelectProps) => {
  const {
    name,
    onChange,
    options,
    value,
    'data-testid': dataTestId
  } = props;
  const selected = String(value);
  return <PopoverSelect underline className={inlineSelectStyles} data-testid={dataTestId} menuClassName={inlineMenuStyles} name={name} options={options.map(option => ({
    ...option,
    value: String(option.value)
  }))} value={selected} onChange={next => {
    if (next !== selected) onChange(next);
  }} />;
};